import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { errorHandling } from './errorHandling';

const LazyEmrysCarsMenu = React.lazy(() => import('Products/EmrysCarsMenu').catch(errorHandling));

const EmrysCarsMenuLoader = () => (
    <ErrorBoundary fallback={<></>}>
        <Suspense fallback={<div></div>}>
            <LazyEmrysCarsMenu />
        </Suspense>
    </ErrorBoundary>
);

export default EmrysCarsMenuLoader;
